// extracted by mini-css-extract-plugin
export var cardsectionbreak = "CentreListingCard-module--cardsectionbreak--d8dc0";
export var centrecardcontainer = "CentreListingCard-module--centrecardcontainer--59d9a";
export var centrecardimage = "CentreListingCard-module--centrecardimage--6faf9";
export var centrecardimagewrapper = "CentreListingCard-module--centrecardimagewrapper--398ba";
export var centrecardlinkscontainer = "CentreListingCard-module--centrecardlinkscontainer--bb72f";
export var centrelocation = "CentreListingCard-module--centrelocation--7b7bf";
export var centrelocationcontainer = "CentreListingCard-module--centrelocationcontainer--60e70";
export var centrename = "CentreListingCard-module--centrename--f2368";
export var distance = "CentreListingCard-module--distance--6010a";
export var maplink = "CentreListingCard-module--maplink--f4546";
export var phone = "CentreListingCard-module--phone--facb7";
export var rehomingcentretext = "CentreListingCard-module--rehomingcentretext--a21a4";
export var title = "CentreListingCard-module--title--98b0a headings-module--signpostHeadingXSmall--3be29";